import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MultiDropdownService {
  public dataFilterChanged$ = new Subject<any>();

  constructor() {}
}
